"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStyles = exports.StickyContainer = void 0;
var react_1 = __importDefault(require("react"));
var useScrollPosition_1 = require("../../hooks/useScrollPosition");
var styles_1 = require("../../styles");
function StickyContainer(props) {
    var top = props.top, left = props.left, style = props.style, rest = __rest(props, ["top", "left", "style"]);
    var scroll = useScrollPosition_1.useScrollPosition();
    var position = scroll.scrollY > top ? 'fixed' : 'absolute';
    var _a = styles_1.useStyles(exports.createStyles, props, position), classes = _a.classes, css = _a.css;
    return react_1.default.createElement("div", __assign({ className: css(classes.container, style) }, rest));
}
exports.StickyContainer = StickyContainer;
exports.createStyles = function (theme, _a, position) {
    var left = _a.left, top = _a.top;
    return ({
        container: {
            position: position,
            top: position === 'fixed' ? 0 : top,
            left: left,
            width: '100%',
            zIndex: 2,
        },
    });
};
//# sourceMappingURL=StickyContainer.js.map